import { render, staticRenderFns } from "./goodCard.vue?vue&type=template&id=26273816&scoped=true"
import script from "./goodCard.vue?vue&type=script&lang=js"
export * from "./goodCard.vue?vue&type=script&lang=js"
import style0 from "./goodCard.vue?vue&type=style&index=0&id=26273816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26273816",
  null
  
)

export default component.exports